export const galwayCoordinates: Record<string, { lat: number; lng: number }> = {
  // Dublin (start point — pickup)
  'Dublin Airport': { lat: 53.4264, lng: -6.2499 },

  // Galway city
  'Latin Quarter, Galway': { lat: 53.272, lng: -9.0532 },
  'Sea Road, Galway': { lat: 53.2706, lng: -9.06 },
  'Shop Street, Galway': { lat: 53.2718, lng: -9.0527 },
  'Mary Street, Galway': { lat: 53.2729, lng: -9.0528 },
  'Cross Street, Galway': { lat: 53.2716, lng: -9.0531 },
  'Spanish Arch, Galway': { lat: 53.2697, lng: -9.0537 },
  'Spanish Parade, Galway': { lat: 53.2697, lng: -9.0541 },
  'Church Lane, Galway': { lat: 53.2724, lng: -9.0533 },
  'Gaol Road, Galway': { lat: 53.2745, lng: -9.0599 },
  'Claddagh, Galway': { lat: 53.2682, lng: -9.057 },
  'Lower Dominick Street, Galway': { lat: 53.2702, lng: -9.0566 },
  'Salthill, Galway': { lat: 53.2628, lng: -9.0833 },

  // Day-trip stops
  'Kinvara, Co. Galway': { lat: 53.1394, lng: -8.9344 },
  'Burren National Park': { lat: 53.0017, lng: -9.04 },
  'Cliffs of Moher': { lat: 52.9715, lng: -9.4309 },
  'Lisdoonvarna, Co. Clare': { lat: 53.0306, lng: -9.2914 },
};

export const galwayCenter = { lat: 53.272, lng: -9.0532 };
